/**
 * API client for the platform/placement spec registry.
 *
 * The registry is read-only and small enough to fetch once per (platform, ad_type).
 * Backed by `src/api/routers/platform_specs.py`.
 */
import { apiClient } from './client';
import type {
  Platform,
  PlatformPlacementSpec,
  PlatformSpecsResponse,
} from '@/types/platformSpecs';

export interface ListPlatformSpecsParams {
  platform?: Platform;
  /** Requires `platform` to also be set. */
  ad_type?: string;
}

export async function listPlatformSpecs(
  params: ListPlatformSpecsParams = {}
): Promise<PlatformPlacementSpec[]> {
  const response = await apiClient.get<PlatformSpecsResponse>('/platform-specs', {
    params,
  });
  return response.data.specs;
}
